import Button from "./button.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrButton = install(Button); // 生成带有 install 方法的组件

export default KrButton;
